<!-- Floating In-App Push Notification Toasts -->
<div class="chat-toast-container" *ngIf="activeToasts.length > 0">
  <div
    *ngFor="let toast of activeToasts"
    class="chat-toast-card"
    (click)="onToastClick(toast)"
  >
    <div class="chat-toast-avatar">
      <img
        *ngIf="toast.senderAvatar; else initialsTpl"
        [src]="toast.senderAvatar"
        [alt]="toast.senderName"
      />
      <ng-template #initialsTpl>
        <span class="chat-toast-initials">{{ toast.senderInitials }}</span>
      </ng-template>
    </div>
    <div class="chat-toast-content">
      <div class="chat-toast-header">
        <span class="chat-toast-name">{{ toast.senderName }}</span>
        <span class="chat-toast-badge">New Message</span>
      </div>
      <div class="chat-toast-body">
        {{ toast.messageText }}
      </div>
    </div>
    <div class="chat-toast-actions">
      <button
        type="button"
        class="chat-toast-close"
        (click)="dismissToast(toast.id, $event)"
        title="Dismiss"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
  </div>
</div>

<div class="footer-chat-dock" *ngIf="showDock">
  <div class="footer-shell">
    <div class="dock-row">
    <!-- Dock unit: panel + footer tabs as one connected block -->
    <div class="dock-unit" [class.is-open]="panelOpen">
      <div class="dock-panel" *ngIf="panelOpen">
        <div class="dock-panel-header">
          <div class="dock-user">
            <span class="dock-user-avatar">{{ userInitials }}</span>
            <div class="dock-user-info">
              <span class="dock-user-name">{{ userName }}</span>
              <span
                class="dock-user-status"
                [class.dock-user-status--offline]="connectionStatus === 'offline'"
                [class.dock-user-status--reconnecting]="
                  connectionStatus === 'reconnecting' ||
                  connectionStatus === 'connecting' ||
                  connectionStatus === 'online'
                "
              >
                {{ connectionStatusLabel }}
              </span>
            </div>
          </div>
          <div class="dock-panel-actions">
            <button type="button" class="dock-icon-btn" (click)="minimizePanel()" title="Minimize">
              <i class="pi pi-minus"></i>
            </button>
            <!-- <button type="button" class="dock-icon-btn" (click)="closeAll()" title="Close">
              <i class="pi pi-times"></i>
            </button> -->
          </div>
        </div>

        <div class="dock-search">
          <i class="pi pi-search"></i>
          <input
            type="text"
            class="dock-search-input"
            placeholder="Search Contacts, Chats &amp; Channels"
            [(ngModel)]="searchQuery"
          />
        </div>

        <div class="dock-panel-content">
          <app-channel-list
            [activeChannelId]="activeChannelId"
            [viewTab]="activeTab"
            [channelsSubTabPreference]="channelsSubTabPreference"
            variant="dock"
            [showHeader]="false"
            [externalSearch]="searchQuery"
            (channelSelected)="onChannelSelected($event)"
          ></app-channel-list>
        </div>
      </div>

      <!-- Footer tabs — always visible, connected to panel above -->
      <nav class="footer-tab-bar">
        <div class="footer-tab-items">
          <button type="button" class="footer-tab-item" [class.active]="panelOpen && activeTab === 'chats'"
            (click)="openTab('chats')">
            <i class="pi pi-comment"></i>
            <span *ngIf="directUnread > 0" class="footer-tab-badge">
              {{ directUnread > 99 ? '99+' : directUnread }}
            </span>
          </button>
          <button type="button" class="footer-tab-item" [class.active]="panelOpen && activeTab === 'channels'"
            (click)="openTab('channels')">
            <i class="pi pi-users"></i>
            <span *ngIf="channelUnread > 0" class="footer-tab-badge">
              {{ channelUnread > 99 ? '99+' : channelUnread }}
            </span>
          </button>
          <button type="button" class="footer-tab-item" [class.active]="panelOpen && activeTab === 'contacts'"
            (click)="openTab('contacts')">
            <i class="pi pi-user"></i>
          </button>
        </div>
      </nav>
    </div>

    <!-- Conversation window — opens to the right of the dock -->
    <div class="dock-conversation" *ngIf="activeChannel"
         [class.expanded]="conversationSize === 'expanded'"
         [class.minimized]="conversationMinimized">
      <div class="dock-conversation-header"
           [class.clickable]="conversationMinimized"
           (click)="onMinimizedHeaderClick()">
        <div class="dock-conversation-info">
          <span class="dock-conversation-avatar" aria-hidden="true">{{ conversationAvatarInitials }}</span>
          <div class="dock-conversation-text">
            <span class="dock-conversation-title">{{ getChannelTitle() }}</span>
            <button
              *ngIf="showParticipantLink"
              type="button"
              class="dock-conversation-link"
              (click)="openParticipantsDialog(); $event.stopPropagation()"
            >
              {{ participantCountLabel }}
            </button>
          </div>
        </div>
        <div class="dock-conversation-actions">
          <ng-container *ngIf="!conversationMinimized">
            <!-- Actions menu -->
            <!-- <div class="dock-actions-dropdown" [class.open]="actionsMenuOpen">
              <button type="button" class="dock-icon-btn" (click)="toggleActionsMenu(); $event.stopPropagation()" title="More actions">
                <i class="pi pi-ellipsis-h"></i>
              </button>
              <div class="dock-actions-menu" *ngIf="actionsMenuOpen">
                <button class="dock-menu-item" (click)="closeActionsMenu(); $event.stopPropagation()">
                  <i class="pi pi-clock"></i><span>Recent Chats</span>
                </button>
                <button class="dock-menu-item" (click)="closeActionsMenu(); $event.stopPropagation()">
                  <i class="pi pi-users"></i><span>Team Channels</span>
                </button>
                <button class="dock-menu-item" (click)="closeActionsMenu(); $event.stopPropagation()">
                  <i class="pi pi-thumbtack"></i><span>Pinned Conversations</span>
                </button>
                <div class="dock-menu-divider"></div>
                <button class="dock-menu-item" disabled (click)="closeActionsMenu(); $event.stopPropagation()">
                  <i class="pi pi-external-link"></i><span>Open in New Window</span>
                </button>
              </div>
            </div> -->
            <button type="button" class="dock-icon-btn" (click)="minimizeConversation(); $event.stopPropagation()" title="Minimize">
              <i class="pi pi-minus"></i>
            </button>
            <button type="button" class="dock-icon-btn" (click)="toggleExpand(); $event.stopPropagation()"
                    [title]="conversationSize === 'expanded' ? 'Restore' : 'Expand'">
              <i class="pi" [ngClass]="conversationSize === 'expanded' ? 'pi-window-minimize' : 'pi-window-maximize'"></i>
            </button>
          </ng-container>
          <button type="button" class="dock-icon-btn" (click)="closeChatWindow(); $event.stopPropagation()" title="Close">
            <i class="pi pi-times"></i>
          </button>
        </div>
      </div>
      <div class="dock-conversation-body">
        <app-chat-window
          #chatWindow
          [channel]="activeChannel"
          [showHeader]="false"
          [showInlineGroupMembers]="true"
          [renderInlineParticipantLink]="false"
          [isMinimized]="conversationMinimized"
        ></app-chat-window>
      </div>
    </div>
    </div>
  </div>
</div>
